import React from "react";
import { useField } from "formik";
import { TextField } from "@material-ui/core";

const TextAreaComponent = ({ name, label, disabled = false }) => {
  const [field, meta] = useField(name);

  return (
    <TextField
      {...field}
      label={label}
      multiline
      error={meta.touched && Boolean(meta.error)}
      fullWidth
      helperText={meta.touched && meta.error}
      disabled={disabled}
    />
  );
};

export default TextAreaComponent;
